import ModalComponent from 'components/ModalComponent';
import { IntegrationType } from './OutputsList';
import DropdownComponent from 'components/DropdownComponent';
import TableComponent, { IColumnProps } from 'components/TableComponent';
import ButtonComponent from 'components/ButtonComponent';
import { useContext, useEffect, useState } from 'react';
import {
  useGetAllMoniIntegrationsAsync,
  useGetMoniIntegrationByIdAsync,
} from 'services/IntegrationService/MoniService/hooks/useMutation';
import { Box } from '@mui/material';
import { IOutputsProps } from 'services/AlarmCentralService/Virtual/types';
import { AppContext } from 'context/AppContextProvider';
import {
  useGetAllSigmaIntegrationsAsync,
  useGetSigmaIntegrationByIdAsync,
} from 'services/IntegrationService/SigmaService/hooks/useMutation';
import {
  useGetAllSurgardIntegrationAsync,
  useGetSurgardIntegrationByIdAsync,
} from 'services/IntegrationService/SurgardService/hooks/useMutation';
import { useGetAllTelegramIdsByLicense } from 'services/TelegramIdsService/hooks/useQuery';
import { useGetWhatsAppNumber } from 'services/WhatsAppNumberService/hooks/useMutation';
import { useGetAllWhatsAppNumbersByLicense } from 'services/WhatsAppNumberService/hooks/useQuery';
import { useGetTelegramIdById } from 'services/TelegramIdsService/hooks/useMutation';
import {
  useGetAllDevicesByLicenseAsync,
  useGetDeviceByIdAsync,
} from 'services/Devices/hooks/useMutation';
import ButtonActionsComponent from 'components/ButtonActionsComponent';
import ConfirmDeleteModalComponent from 'components/ConfirmDeleteModalComponent';
import {
  useGetOutputsOfAlarmCentralId,
  useUpdateOutputsOfAlarmCentralId,
} from '../../../../services/AlarmCentralService/Physical/hooks/useMutation';

interface OutputManagementModalProps {
  isOpen: boolean;
  onClose: () => void;
  alarmCentral: any;
  integrationTypeSelected?: IntegrationType;
}

const OutputManagementModal = ({
  isOpen,
  onClose,
  integrationTypeSelected,
  alarmCentral,
}: OutputManagementModalProps) => {
  const { showSnackbar } = useContext(AppContext);
  const columns: IColumnProps[] = [
    { label: 'Nome', id: 'name' },
    {
      id: 'id',
      label: 'Ações',
      align: 'center',
      width: 0,
      render: (id) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          handleDelete={() => handleDeleteItem(Number(id))}
        />
      ),
    },
  ];
  const [outputsRender, setOutputsRender] = useState<any[]>([]);
  const { mutateAsync: mutateGetOutputsOfAlarmCentralId } =
    useGetOutputsOfAlarmCentralId();
  const [isAddOutputModal, setIsAddOutputModal] = useState(false);
  const [outputId, setOutputId] = useState();
  const [isVisibleDeleteItemModal, setIsVisibleDeleteItemModal] =
    useState<boolean>(false);
  const [outputsToSelected, setOutputsToSelected] = useState<any[]>([]);
  const [alarmCentralSelectedOutputs, setAlarmCentralSelectedOutputs] =
    useState<IOutputsProps>();
  const additionalComponent = () => {
    return (
      <ButtonComponent size="small" onClick={() => setIsAddOutputModal(true)}>
        + Adicionar saída
      </ButtonComponent>
    );
  };
  const [selectedItemIdToDelete, setSelectedItemIdToDelete] = useState<any>();

  const { mutateAsync: mutateGetMoniIntegrationByIdAsync } =
    useGetMoniIntegrationByIdAsync();
  const { mutateAsync: mutateGetSigmaIntegrationByIdAsync } =
    useGetSigmaIntegrationByIdAsync();
  const { mutateAsync: mutateGetSurgardIntegrationByIdAsync } =
    useGetSurgardIntegrationByIdAsync();
  const { mutateAsync: mutateGetWhatsAppNumberAsync } = useGetWhatsAppNumber();
  const { mutateAsync: mutateGetTelegramIdById } = useGetTelegramIdById();
  const { mutateAsync: mutateGetDeviceById } = useGetDeviceByIdAsync();

  const { mutateAsync: mutateGetAllMoniIntegrationsAsync } =
    useGetAllMoniIntegrationsAsync();
  const { mutateAsync: mutateGetAlSurgardIntegrationsAsync } =
    useGetAllSurgardIntegrationAsync();
  const { mutateAsync: mutateGetAllSigmaIntegrationsAsync } =
    useGetAllSigmaIntegrationsAsync();
  const { data: whatsAppNumbersByLicense } =
    useGetAllWhatsAppNumbersByLicense();
  const { data: telegramIdsByLicense } = useGetAllTelegramIdsByLicense();
  const { mutateAsync: mutateGetAllByLicenseAsync } =
    useGetAllDevicesByLicenseAsync();

  const {
    mutateAsync: mutateUpdateOutputsOfAlarmCentralId,
    isLoading: isLoadingUpdateOutputsOfAlarmCentralId,
  } = useUpdateOutputsOfAlarmCentralId();

  const handleDeleteItem = (id: number) => {
    setSelectedItemIdToDelete(id);
    setIsVisibleDeleteItemModal(true);
  };

  const handleCloseAndClearDelete = () => {
    setIsVisibleDeleteItemModal(false);
    setSelectedItemIdToDelete(undefined);
  };

  const handleConfirmDeletion = () => {
    if (selectedItemIdToDelete) {
      setOutputsRender(
        outputsRender.filter((item) => item.id != selectedItemIdToDelete),
      );
      handleCloseAndClearDelete();
    }
  };

  const handleEdit = (id: number) => {
    // mutateIvsDeviceAsync(id).then(setDeviceToEdit);
    // setIsVisibleEditionModal(true);
  };

  const handleOutputTitle = () => {
    switch (integrationTypeSelected) {
      case 'DEVICES':
        return 'Dispositivos';
      case 'SIGMA':
        return 'Sigma';
      case 'MONI':
        return 'Moni';
      case 'WHATSAPP':
        return 'WhatsApp';
      case 'TELEGRAM':
        return 'Telegram';
      case 'SURGARD':
        return 'Surgard';
      default:
        return '';
    }
  };

  const onCloseOutputEdition = () => {
    setOutputsRender([]);
    onClose();
  };

  const handleSaveOutputs = async () => {
    const ids: any[] = [];
    outputsRender.forEach((v) => ids.push(v.id));
    const out = { ...alarmCentralSelectedOutputs };
    switch (integrationTypeSelected) {
      case 'MONI':
        out.moniIds = ids;
        break;
      case 'SIGMA':
        out.sigmaIds = ids;
        break;
      case 'SURGARD':
        out.surgardIds = ids;
        break;
      case 'WHATSAPP':
        out.whatsAppIds = ids;
        break;
      case 'TELEGRAM':
        out.telegramIds = ids;
        break;
      case 'DEVICES':
        out.deviceOutIds = ids;
        break;
    }

    if (alarmCentral.id && out)
      await mutateUpdateOutputsOfAlarmCentralId(
        {
          alarmCentralId: alarmCentral.id,
          outputs: out,
        },
        {
          onSuccess: () => {
            showSnackbar('Saídas atualizadas com sucesso.', 'success');
            onClose();
          },
        },
      );

    setOutputsToSelected([]);
    setOutputsRender([]);
  };

  const getOutputs = () => {
    if (alarmCentral.id) {
      mutateGetOutputsOfAlarmCentralId(alarmCentral.id).then(
        setAlarmCentralSelectedOutputs,
      );
    }
  };

  useEffect(() => {
    if (isOpen) getOutputs();
  }, [isOpen]);

  useEffect(() => {
    if (alarmCentralSelectedOutputs) {
      switch (integrationTypeSelected) {
        case 'MONI':
          alarmCentralSelectedOutputs.moniIds?.forEach((m) =>
            mutateGetMoniIntegrationByIdAsync(m).then((mr) =>
              setOutputsRender((oldStt) => [...oldStt, mr]),
            ),
          );
          break;
        case 'SIGMA':
          alarmCentralSelectedOutputs.sigmaIds?.forEach((m) =>
            mutateGetSigmaIntegrationByIdAsync(m).then((mr) =>
              setOutputsRender((oldStt) => [...oldStt, mr]),
            ),
          );
          break;
        case 'SURGARD':
          alarmCentralSelectedOutputs.surgardIds?.forEach((m) =>
            mutateGetSurgardIntegrationByIdAsync(m).then((ms) =>
              setOutputsRender((oldStt) => [...oldStt, ms]),
            ),
          );
          break;
        case 'WHATSAPP':
          alarmCentralSelectedOutputs.whatsAppIds?.forEach((m) =>
            mutateGetWhatsAppNumberAsync(m).then((ms) =>
              setOutputsRender((oldStt) => [...oldStt, ms]),
            ),
          );
          break;
        case 'TELEGRAM':
          alarmCentralSelectedOutputs.telegramIds?.forEach((m) =>
            mutateGetTelegramIdById(m).then((ms) =>
              setOutputsRender((oldStt) => [...oldStt, ms]),
            ),
          );
          break;
        case 'DEVICES':
          alarmCentralSelectedOutputs.deviceOutIds?.forEach((m) =>
            mutateGetDeviceById(m).then((ms) =>
              setOutputsRender((oldStt) => [...oldStt, ms]),
            ),
          );
          break;
      }
    }
  }, [alarmCentralSelectedOutputs]);

  useEffect(() => {
    if (isAddOutputModal) {
      switch (integrationTypeSelected) {
        case 'DEVICES':
          mutateGetAllByLicenseAsync({}).then((d) => {
            setOutputsToSelected(d.filter((dev) => dev.type === 'TUYA'));
          });
          break;
        case 'SIGMA':
          mutateGetAllSigmaIntegrationsAsync().then(setOutputsToSelected);
          break;
        case 'MONI':
          mutateGetAllMoniIntegrationsAsync().then(setOutputsToSelected);
          break;
        case 'WHATSAPP':
          if (whatsAppNumbersByLicense)
            setOutputsToSelected(whatsAppNumbersByLicense);
          break;
        case 'TELEGRAM':
          if (telegramIdsByLicense) setOutputsToSelected(telegramIdsByLicense);
          break;
        case 'SURGARD':
          mutateGetAlSurgardIntegrationsAsync().then(setOutputsToSelected);
          break;
      }
    }
  }, [
    integrationTypeSelected,
    isAddOutputModal,
    whatsAppNumbersByLicense,
    telegramIdsByLicense,
  ]);

  return (
    <>
      <ModalComponent
        isOpen={isOpen}
        onClose={() => onCloseOutputEdition()}
        title={handleOutputTitle()}
      >
        <TableComponent
          rows={outputsRender}
          columns={columns}
          title={'Saídas'}
          additionalTitleComponent={additionalComponent()}
          emptyMessage={'Nenhuma saída ' + handleOutputTitle() + ' registrada.'}
        />
        <Box sx={{ display: 'flex', mt: 3, justifyContent: 'flex-end' }}>
          <ButtonComponent
            onClick={() => handleSaveOutputs()}
            loading={isLoadingUpdateOutputsOfAlarmCentralId}
          >
            Salvar
          </ButtonComponent>
        </Box>
      </ModalComponent>

      <ModalComponent
        isOpen={isAddOutputModal}
        title="Selecionar saída"
        onClose={() => {
          setOutputsToSelected([]);
          setIsAddOutputModal(false);
          setOutputId(undefined);
        }}
      >
        <DropdownComponent
          label="Saída"
          options={outputsToSelected}
          onChange={(val) => {
            setOutputId(val);
            setIsAddOutputModal(false);
            setOutputsRender((oldStt) => [
              ...oldStt,
              outputsToSelected.find((v) => v.id == val) ?? 0,
            ]);
          }}
          optionLabel="name"
          optionValue="id"
          value={outputId}
        />
      </ModalComponent>

      <ConfirmDeleteModalComponent
        // isLoading={isLoadingDeleteVirtualAlarmCentralDeviceById}
        isVisibleDeleteDialog={isVisibleDeleteItemModal}
        setIsVisibleDeleteDialog={setIsVisibleDeleteItemModal}
        title={'Excluir Dispositivo'}
        message={`Tem certeza que deseja desvincular essa saída?`}
        handleCancelDeletion={handleCloseAndClearDelete}
        handleConfirmDeletion={handleConfirmDeletion}
      />
    </>
  );
};

export default OutputManagementModal;
